import Vue from 'vue'

/**
 * 日期格式化
 * @param fmt   yyyy-MM-dd hh:mm:ss S
 * @returns {*}
 */
Date.prototype.format = function (fmt = 'yyyy-MM-dd hh:mm:ss') {
    const o = {
        'M+': this.getMonth() + 1,                          //月份
        'd+': this.getDate(),                               //日
        'h+': this.getHours(),                              //小时
        'm+': this.getMinutes(),                            //分
        's+': this.getSeconds(),                            //秒
        'q+': Math.floor((this.getMonth() + 3) / 3),     //季度
        'S': this.getMilliseconds()                         //毫秒
    };

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (String(this.getFullYear())).substr(4 - RegExp.$1.length));
    }

    for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(String(o[k]).length)));
        }
    }
    return fmt;
}

/**
 * 检查数字，如果为NaN || Infinity 都返回0
 * @param n
 */
Vue.prototype.formatNumber = function (n) {
    return (isNaN(n) || n === Infinity || n === undefined) ? 0 : Number(n.toFixed(2));
};

/**
 * 阻止事件冒泡
 * @param e
 * @returns {*}
 */
Vue.prototype.stopPropagation = e => e.stopPropagation();

/**
 * 格式化日期，自动简化日期
 * @param datetime
 * @returns {*}
 */
window.formatTime = function (datetime) {
    const d = new Date(datetime);
    let format = 'yyyy-MM-dd';

    if (datetime.search('00:00:00') === -1) {
        format += ' hh:mm:ss';
    }

    return d.format(format);
}

window.nothingtodo = () => {
    //空函数，什么也不做。
};

window.noop = window.nothingtodo;

/**
 * 根据列名获取表格数据中的某一列数据，返回一个新数组
 * @param column
 * @returns {[]}
 */
Array.prototype.getColumn = function (column) {
    const result = [];
    for (let i = 0; i < this.length; i++) {
        result.push(this[i][column]);
    }
    return result;
}

/**
 * 删除数组某个数据
 * @param dx    下标
 * @returns {boolean}
 */
Array.prototype.removeByIndex = function (dx) {
    this.splice(dx, 1);
};

/**
 * 根据值删除数组的某个数据
 * @param val   值
 */
Array.prototype.remove = function (val) {
    let index = this.indexOf(val);
    if (index === -1) return -1;
    this.removeByIndex(index);
};

/**
 * 数组去重，ES6语法
 * @returns {*[]}
 */
Array.prototype.unique = function () {
    return Array.from(new Set(this))
}

/**
 * 获取一个排序函数供Array sort 方法使用，专用来排列数组中的对象，按照某一键值
 * @param column    需要排序的字段
 * @param sortby    ASC DESC
 * @returns {function(...[*]=)}
 */
Array.getSorter = function (column, sortby) {
    return (a, b) => {
        if (sortby === 'ASC') {
            if (a[column] < b[column]) {
                return -1;
            }

            if (a[column] > b[column]) {
                return 1;
            }

            return 0;
        }

        if (sortby === 'DESC') {
            if (a[column] > b[column]) {
                return -1;
            }

            if (a[column] < b[column]) {
                return 1;
            }

            //return < 0  a b
            //return = 0  位置不变
            //return > 0  b a
            return 0;
        }
    }
}

String.prototype.trim = function () {
    return this.replace(/(^\s*)|(\s*$)/g, "");
}
String.prototype.ltrim = function () {
    return this.replace(/(^\s*)/g, "");
}
String.prototype.rtrim = function () {
    return this.replace(/(\s*$)/g, "");
}

/**
 * 对象赋值拷贝，将一部分的对象值拷贝到被赋值对象中
 * @param left      被赋值对象
 * @param right     需要拷贝的对象
 * @param opt       映射表，部分左右KEY不一致的对象需要拷贝的映射表
 * @param deepcopy  可选 deepcopy 深拷贝时，将会产生一个新的实例拷贝 ⚠：这个函数最好只用来拷贝数据。
 */
window.assignObject = function (left, right, opt = {}, deepcopy = false) {
    const [optleftkeys, optrightkeys] = [Object.keys(opt), Object.values(opt)];

    for (const rightkey in right) {
        //修正webstorm错误提示
        if (!right.hasOwnProperty(rightkey)) continue;

        let leftkey = rightkey,
            index = optrightkeys.indexOf(rightkey);

        if (index > -1)
            leftkey = optleftkeys[index];

        if (leftkey in left)
            left[leftkey] = deepcopy ? window.deepCopy(right[rightkey]) : right[rightkey];
    }
}

/**
 * 深拷贝
 * @param {*} obj 拷贝对象(object or array)
 * @param {*} cache 缓存数组
 */
window.deepCopy = function (obj, cache = []) {
    // typeof [] => 'object'
    // typeof {} => 'object'
    if (obj === null || typeof obj !== 'object') {
        return obj
    }
    // 如果传入的对象与缓存的相等, 则递归结束, 这样防止循环
    /**
     * 类似下面这种
     * let a = {b:1}
     * a.c = a
     * 资料: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
     */
    const hit = cache.filter(c => c.original === obj)[0]
    if (hit)
        return hit.copy;

    const copy = Array.isArray(obj) ? [] : {}
    // 将copy首先放入cache, 因为我们需要在递归deepCopy的时候引用它
    cache.push({
        original: obj,
        copy
    })

    Object.keys(obj).forEach(key => {
        copy[key] = window.deepCopy(obj[key], cache)
    })

    return copy
}

/**
 * 把某对象中的数组和对象转换成JSON文本
 * @param object
 */
window.changetoJSON = function (object) {
    for (const key in object) {
        if (!object.hasOwnProperty(key)) continue;
        if (Array.isArray(object[key]) || typeof object[key] === 'object')
            object[key] = JSON.stringify(object[key]);
    }
}

/**
 * 批量下载文件
 * @param filelist 实际文件名 列表
 * @param file_server
 */
window.download = function (filelist, file_server = '220.176.162.87:8000/images/') {
    const downlist = [...filelist];

    const foo = () => {
        const object = downlist.shift();
        if (object === undefined) return;

        let url = object, 文件名 = '';
        if (typeof object === 'object') {
            文件名 = object.虚拟文件名;
            url = object.实际文件名;
        }
        const suffix = typeof object === 'object' ? object.实际文件名.split('.').pop() : url.split('.').pop();

        let x = new XMLHttpRequest();

        x.open('GET', `http://${file_server}${url}`, true);
        x.responseType = 'blob';
        x.onload = () => {
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(x.response);
            a.download = [文件名, suffix].join('.');
            a.click();
        }
        x.send();

        setTimeout(foo, 360); //太快的话会终止下载
    }

    foo();
}

/**
 * 文件字节转换为单位
 * @param size
 * @return {string}
 */
window.getFileSize = size => {
    if (!size) return '';
    const num = 1024.00; //byte
    if (size < num)
        return size + 'B';
    if (size < Math.pow(num, 2))
        return (size / num).toFixed(2) + 'KB'; //kb
    if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + 'MB'; //M
    if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + 'G'; //G
    return (size / Math.pow(num, 4)).toFixed(2) + 'T'; //T
};

/**
 * 判断这个imei是否是正确的 正确返回ture 错误返回false
 * 来自CSDN https://blog.csdn.net/u014421520/article/details/88257903
 * @param imeiString
 * @returns {boolean}
 */
window.isIMEI = function (imeiString) {
    let i;
    let vl_Sum1 = 0, vl_Sum2 = 0, vl_Total;
    let vl_Temp = 0;

    for (i = 0; i < 14; i++) {
        /*(1)将奇数位数字相加(从1开始计数)*/
        if ((i % 2) === 0) {
            vl_Sum1 = vl_Sum1 + parseInt(imeiString[i]);
        } else {
            /*(2)将偶数位数字分别乘以2,分别计算个位数和十位数之和(从1开始计数)*/
            vl_Temp = (parseInt(imeiString[i])) * 2;
            if (vl_Temp < 10) {
                vl_Sum2 = vl_Sum2 + vl_Temp;
            } else {
                vl_Sum2 = vl_Sum2 + 1 + vl_Temp - 10;
            }
        }
    }
    /*(1)+(2)*/
    vl_Total = vl_Sum1 + vl_Sum2;
    /*如果得出的数个位是0则校验位为0,否则为10减去个位数 */
    if ((vl_Total % 10) === 0) {
        if (imeiString[14] === '0') {
            return true;
        }
    } else {
        if ((10 - (vl_Total % 10)).toString() === imeiString[14]) {
            return true;
        }
    }

    return false;
};

/**
 * 十六进制转换rgb
 * @param string
 * @param opacity   透明度参数
 * @returns {string}
 */
window.colorRgb = function (string, opacity = 1) {
    let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    let sColor = string.toLowerCase();
    if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
            let sColorNew = "#";
            for (let i = 1; i < 4; i += 1) {
                sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
            }
            sColor = sColorNew;
        }
        //处理六位的颜色值
        let sColorChange = [];
        for (let i = 1; i < 7; i += 2) {
            sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        return `rgba(${sColorChange.join(`,`)},${opacity})`;
    } else {
        return sColor;
    }
};


/**
 *获取两个日期间的所有日期
 *默认start<end
 */
window.getDiffDate = function (start, end) {
    /**
     *datestr:形如‘2017-06-12’的字符串
     *return Date 对象
     */
    const getDate = function (datestr) {
        let temp = datestr.split("-");
        if (temp[1] === '01') {
            temp[0] = parseInt(temp[0], 10) - 1;
            temp[1] = '12';
        } else {
            temp[1] = parseInt(temp[1], 10) - 1;
        }
        //new Date()的月份入参实际都是当前值-1
        return new Date(temp[0], temp[1], temp[2]);
    };

    let startTime = getDate(start);
    let endTime = getDate(end);
    let dateArr = [];
    while ((endTime.getTime() - startTime.getTime()) > 0) {
        let year = startTime.getFullYear();
        let month = (startTime.getMonth() + 1).toString().length === 1 ? "0" + (parseInt(startTime.getMonth().toString(), 10) + 1) : (startTime.getMonth() + 1);
        let day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
        dateArr.push(year + "-" + month + "-" + day);
        startTime.setDate(startTime.getDate() + 1);
    }
    return dateArr;
}

/**
 * 生成一个唯一ID
 * getUUID(8, 2)   //"01001010" 8 character (base=2)
 * getUUID(8, 10) // "47473046" 8 character ID (base=10)
 * getUUID(8, 16) // "098F4D35"。 8 character ID (base=16)
 * @param len              长度
 * @param radix            进制
 * @param prefix           是否要加前缀，字符串
 * @returns {string}       uuid
 */
window.getUUID = function (len = 8, radix = 16, prefix = '') {
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    let uuid = [], i;
    radix = radix || chars.length;
    if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
        let r;
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    if (prefix) {
        return prefix + uuid.join('');
    } else {
        return uuid.join('');
    }
}


/**
 * 设置COOKIE
 * @param name  名字
 * @param value 值
 */
window.setCookie = function (name, value) {
    let Days = 30; //此 cookie 将被保存 30 天
    let exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);//24*60*60*1000=1天
    if (typeof value === `object`) {
        value = JSON.stringify(value);
    }
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
};

/**
 * 删除Cookie
 * @param name 名字
 */
window.delCookie = function (name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = window.getCookie(name);
    if (cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

/**
 * 获取Cookie
 * @param name 名字
 * @returns {string|null}
 */
window.getCookie = function (name) {
    let arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
    if (arr != null) {
        let value = unescape(arr[2]);
        try {
            value = JSON.parse(value);
        } catch (e) {
            window.console.error('error', e)
        }
        return value;
    }
    return null;
};

/**
 * 将数字转换为大写中文
 * @param money
 * @param cap   是否大写中文
 * @returns {string|*}
 */
window.moneyToCN = (money, cap = false) => {
    // NaN !== NaN
    if (Number(money) !== Number(money)) {
        return money
    }
    // 大数位，每四位一节
    const cnFigure = ['', '万', '亿', '万亿']
    // 中文数字0-9
    const cnInteger = cap ? ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'] : ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
    // 十进制计数“个十百千”
    const cnDecimalism = cap ? ['', '拾', '佰', '仟'] : ['', '十', '百', '千']
    // 先转为字符串
    const string = money + ''
    // 小数点分割
    const numbers = string.split('.')
    const integerPart = numbers[0]
    const decimalPart = numbers[1]
    // 整数部分位数
    const len = integerPart.length
    // 四位分节
    const pitch = Math.ceil(len / 4)
    const array = []
    // 分为每四位一节，从低位向高位分
    for (let index = 0; index < pitch; index++) {
        array.push(integerPart.slice((len - (index + 1) * 4 < 0) ? 0 : (len - (index + 1) * 4), len - index * 4))
    }
    // 将四位一节的数字转换为对应的中文，拼接上大数位，比如（一千一百一十一）（万），“一千一百一十一万”
    const cnArray = array.map((figure, index) => {
        const cn = figure.split('').map((char, i) => {
            return char === '0' ? '零' : (cnInteger[Number(char)] + cnDecimalism[figure.length - i - 1])
            // replace末尾的所有“零”，例如“壹仟零零零”变成“壹仟”；再replace中间的多个零，例如“壹万零零零玖”变成“壹万零玖”
        }).join('').replace(/\u96f6+$/, '').replace(/\u96f6+/g, '\u96f6')
        // 防止出现“零零零零”变成“”之后再加大数位，例如“（零零零零）万”变成“万”
        return cn.length ? (cn + cnFigure[index]) : (cnFigure[index] ? '零' : '')
    }).reverse()
    // 整数，替换掉中间连续的“零”，例如“一万亿零（亿）零（万）一千”变为“一万亿零一千”，最后可加上.replace(/^\u4e00\u5341/, '\u5341')，将“一十****”变为“十****”
    const integerCN = cnArray.join('').replace(/\u96f6+/g, '\u96f6')

    let decimalCN = ''
    if (!decimalPart || decimalPart === '0' || decimalPart === '00') {
        decimalCN = '整'
    } else {
        const [p0, p1] = decimalPart.split('')
        decimalCN = (p0 === '0' ? '零' : (cnInteger[Number(p0)] + '角')) + (!p1 || p1 === '0' ? '' : (cnInteger[Number(p1)] + '分'))
    }

    return `${integerCN || '零'}${cap ? '圆' : '元'}${decimalCN}`
}

/**
 * 如果为NaN或则返回0，否则格式化成保留两位小数数字
 * @param n
 * @returns {number}
 */
window.formatNumber = n => (isNaN(n) || n === Infinity) ? 0 : Number(n.toFixed(2));

let top = 0;

/**
 * 锁住body禁止滚动
 */
window.lockbody = function () {
    top = window.scrollY;

    document.body.style.position = 'fixed';
    document.body.style.top = -top + 'px';
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';
}

/**
 * 恢复body滚动
 */
window.freebody = function () {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflowY = 'unset';

    window.scrollTo(0, top);
}

/**
 * 只允许鼠标左键触发函数
 */
window.onlyMouseClick = function (event, callback, callbackparams) {
    if (event.screenY !== 0 && event.screenX !== 0) callback(callbackparams);
};

/**
 * 屏蔽字符串，保留 前面 后面，其他替换成指定字符
 * @param string
 * @param 字符
 * @param startindex 从哪个字符开始屏蔽
 * @returns {string}
 */
window.maskString = function (string, 字符 = '*', startindex = 0) {
    if (typeof string !== 'string' || !string) return '';

    if (string.length === 1) return string;
    if (string.length === 2) return string[0] + 字符;

    let result = `${string[startindex]}`;
    for (let i = startindex + 1; i < string.length - 1; i++)
        result += 字符;
    result += string[string.length - 1];

    return result;
}

/**
 * 友好的时间显示
 * @returns {string}
 */
Date.prototype.friendlyTime = function () {
    const now_time_stamp = new Date().getTime();
    const past_time_stamp = this.getTime();

    const 过去距离现在的毫秒 = (now_time_stamp - past_time_stamp) / 1000;

    if (过去距离现在的毫秒 < 60) {
        return '刚刚'; //一分钟内
    } else if (过去距离现在的毫秒 < 60 * 60) {
        return `${Math.floor(过去距离现在的毫秒 / 60)} 分钟前`; //一个小时内
    } else if (过去距离现在的毫秒 < 60 * 60 * 24) {
        return `${Math.floor(过去距离现在的毫秒 / 60 / 60)} 小时前`; // 一天内
    } else if (过去距离现在的毫秒 < 60 * 60 * 24 * 30) {
        return `${Math.floor(过去距离现在的毫秒 / 60 / 60 / 24)} 天前`; // 一个月内
    } else {
        return `${Math.floor(过去距离现在的毫秒 / 60 / 60 / 24 / 30)} 个月前`; // 一年内
    }
}


/**
 * //num代表传入的数字，n代表要保留的字符的长度
 * @param num
 * @param n
 * @returns {string}
 * @constructor
 */
window.PreFixInterge = function (num, n) {
    return (Array(n).join(0) + num).slice(-n);
}

export default {
    install(Vue) {

        /**
         * 公共排序函数，用于组件中的vxe table 操作适用。
         * @param {*} param0
         */
        Vue.prototype.$sortChangeEvent = function ({ property, order }) {
            if (order === null) {
                this.post.排序字段 = "id";
                this.post.排序方式 = "desc";
                this.$message.info("恢复默认ID排序");
            } else {
                this.post.排序字段 = property;
                this.post.排序方式 = order;
            }

            this.onQuery(true);
        }
    }
}

window.mobileCheck = function (value) {
    return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value)
}

/**
 * 判断当前时间与指定时间的小时差是否达到或超过指定小时数
 * @param {string} targetTimeStr - 目标时间字符串，格式如 "2026-01-28 15:06:46"
 * @param {number} hoursThreshold - 要判断的小时阈值，如 48
 * @returns {boolean} - 小时差 >= 阈值返回 true，否则返回 false
 */
window.isHoursDifferenceExceeded = function (targetTimeStr, hoursThreshold) {
    try {
        // 1. 将传入的时间字符串转换为时间戳（毫秒）
        // 注意：JavaScript 能直接解析 "YYYY-MM-DD HH:mm:ss" 格式的字符串
        const targetTime = new Date(targetTimeStr).getTime();

        // 2. 检查时间转换是否有效（无效时间会返回 NaN）
        if (isNaN(targetTime)) {
            throw new Error('传入的时间格式无效，请确保格式为 "YYYY-MM-DD HH:mm:ss"');
        }

        // 3. 获取当前时间的时间戳
        const currentTime = Date.now();

        // 4. 计算时间差（毫秒），再转换为小时（1小时 = 3600000毫秒）
        const timeDiffMs = currentTime - targetTime;
        const timeDiffHours = timeDiffMs / (1000 * 60 * 60);

        // 5. 判断小时差是否大于等于阈值并返回结果
        return timeDiffHours >= hoursThreshold;
    } catch (error) {
        console.error('计算时间差时出错：', error.message);
        // 出错时默认返回 false（也可根据你的业务需求调整）
        return false;
    }
}

/**
 * 根据列名获取表格数据中的某一列数据，返回一个新数组
 * @param column
 * @returns {[]}
 */
Array.prototype.getColumn = function (column) {
    const result = [];
    for (let i = 0; i < this.length; i++) {
        result.push(this[i][column]);
    }
    return result;
}